"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _PassThrough = _interopRequireDefault(require("../PassThrough"));

var _excluded = ["className", "variant", "dataQa", "Component", "ContainerProps", "children"];

var styles = function styles(theme) {
  return {
    text: {
      color: 'inherit',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  };
};

exports.styles = styles;
var containerLookup = {
  text: _Typography["default"]
};
var useStyles = (0, _makeStyles["default"])(styles);

var Link = function Link(_ref) {
  var className = _ref.className,
      variant = _ref.variant,
      dataQa = _ref.dataQa,
      Component = _ref.Component,
      ContainerProps = _ref.ContainerProps,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();
  var Container = containerLookup[variant] || _PassThrough["default"];
  return /*#__PURE__*/_react["default"].createElement(Container, (0, _extends2["default"])({
    color: "primary"
  }, ContainerProps), /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
    "data-qa": dataQa,
    className: (0, _classnames["default"])(className, (0, _defineProperty2["default"])({}, classes.text, variant === 'text'))
  }), children));
};

Link.propTypes = {
  /** Render function */
  Component: _propTypes["default"].oneOfType([function (prop) {
    return prop === undefined;
  }, _propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].elementType]),

  /** The content of the component */
  children: _propTypes["default"].node.isRequired,
  variant: _propTypes["default"].oneOf(['text']),

  /** Props for the containing component, e.g. `Typography` for `variant="text"` */
  ContainerProps: _propTypes["default"].object
};
Link.defaultProps = {
  ContainerProps: {},
  Component: 'a'
};
var _default = Link;
exports["default"] = _default;